import { connect } from 'react-redux'
import AssessmentEntry from './assessment-entry'
import {
  getAssessment,
  getDeletingAssessmentRequest
} from '../../../../../../stores/assessment/assessment.selectors'
import { format } from 'date-fns/esm'

const mapStateToProps = (state, { id }) => {
  const assessment = getAssessment(state, id)
  return {
    date: format(assessment.updated_at, 'dd.MM.yyyy'),
    title: assessment.title,
    link: `/moderation/assessment-files/${id}`,
    contributors: assessment.contributors && assessment.contributors.length,
    conclusion: assessment.concluded,
    pending: getDeletingAssessmentRequest(state, id).pending
  }
}

export default connect(mapStateToProps, null)(AssessmentEntry)
